<template>
  <div id="grid-observacion">
    <div v-if="loading">
      <loading></loading>
    </div>
    <v-container grid-list-xl fluid>
      <!-- TABLA DE CENTROS -->
      <v-layout>
        <v-flex lg12>
          <v-spacer></v-spacer>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn
              v-if="tipeView != 'consulta'"
              color="primary"
              @click="newObservacion()"
              >Nueva Observacion</v-btn
            >
          </v-card-actions>
          <v-data-table
            :headers="headers"
            :items="observaciones"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <!-- <td class="text-xs-left">{{ props.item.estado }}</td> -->
              <td class="text-xs-left">{{ props.item.observaciones }}</td>
              <td class="text-xs-left">{{ props.item.fechaObservaciones }}</td>
              <div v-if="tipeView == 'consulta'" class="text-xs-center">
                <td>
                  <v-btn
                    v-if="tipeView == 'consulta'"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                    title="Ver observacion"
                    @click="viewObservacion(props.item.id)"
                    ><v-icon>remove_red_eye</v-icon>
                  </v-btn>
                  <!-- <v-btn   
                    v-if="tipeView=='modifica'"                
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="primary"
                    small
                    title="Editar observacion"
                    @click="editObservacion(props.item.id)"
                  ><v-icon>open_in_new</v-icon>
                  </v-btn> -->
                </td>
              </div>
            </template>
          </v-data-table>
          <!-- LEYENDA TABLA -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <div class="text-xs-center">
              <td>
                <template v-if="tipeView == 'consulta'">
                  <v-btn
                    class="btn-sigas"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                  >
                    <v-icon>remove_red_eye</v-icon> </v-btn
                  >Ver observacion
                </template>
                <!--  <template v-if="tipeView=='modifica'"   >
                    <v-btn                      
                      class="btn-sigas"
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="primary"
                      small
                    >
                      <v-icon>open_in_new</v-icon>
                    </v-btn>Editar observacion
                  </template>                 -->
              </td>
            </div>
          </v-card-actions>
          <!--fin iconos leyenda-->
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import { misMixins } from "@/mixins/myMixing.js";
export default {
  name: "grid-observacion",
  components: {
    Loading,
  },
  mixins: [misMixins],
  props: {
    rowsTable: "",
  },

  data() {
    return {
      loading: false,
      dialog: false,
      idEstado: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      contratoId: "",
      itemsProgreso: [],
      headers: [
        // { text: "Estado Centro", align: "left", sortable: false, value: "codCentro" },
      ],
      fechaInicioValue: [],
      usuarioLoggedTipe: "",
      bloqueo: Boolean,
      itemsCentro: [],
      regionValue: null,
      regionSelect: [],
      comunaValue: null,
      comunaSelect: [],
      estadoValue: null,
      estadoSelect: [],
      filter: false,
      observaciones: "",
      observacion: "",
      tipeView: "",
    };
  },
  created() {
    // this.loading = true;
    //  this.loadData();
    this.tipeView = this.$parent.$parent.tipeView;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idContrato = this.$store.getters.contratoStored;
    if (this.tipeView == "consulta") {
      this.headers = [
        { text: "Observacion", sortable: false, value: "region" },
        { text: "Fecha", sortable: false, value: "fecha" },
        {
          text: "Accion",
          sortable: false,
          value: "accion",
        },
      ];
    } else {
      this.headers = [
        { text: "Observacion", sortable: false, value: "region" },
        { text: "Fecha", sortable: false, value: "fecha" },
      ];
    }

    this.loadDataObservaciones();
  },

  mounted() {},
  computed: {},
  methods: {
    async loadDataObservaciones() {
      this.loading = true;

      this.observaciones = await this.loadObservacionAll();
      this.loading = false;
      // if (this.observacion.length > 0) {
      //   this.$parent.alerta = false;
      // } else {
      //   this.$parent.alerta = true;
      // }
    },

    async loadObservacionAll() {
      let idContrato = this.$store.getters.contratoStored;

      return await axios
        .get(
          "/centro/observacionesAll/" +
            this.$parent.$parent.idCentro +
            "/" +
            idContrato
        )
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    newObservacion() {
      this.$parent.$parent.observacion = "";
      this.$parent.$parent.reloadObservacion();
    },

    async viewObservacion(idObs) {
      this.loading = true;
      this.observacion = await this.loadObservacion(idObs);
      this.loading = false;
      if (
        this.observacion.id !== undefined &&
        this.observacion.id != null &&
        this.observacion.id != ""
      ) {
        this.$parent.$parent.observacion = this.observacion.observaciones;
        this.$parent.$parent.estadoCentroValue = this.observacion.estado;
        this.$parent.$parent.estadoCentroSelect = [this.observacion.estado];
        this.$parent.$parent.reloadObservacion();
      }
    },

    async loadObservacion(idObs) {
      let idContrato = this.$store.getters.contratoStored;
      return await axios
        .get("/centro/observaciones/" + idObs + "/" + idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
  },
};
</script>
